module.exports = __webpack_public_path__ + "public/img/robo.73333f91.svg";